import { render, staticRenderFns } from "./SheetActionButton.vue?vue&type=template&id=540a2ef0&scoped=true"
import script from "./SheetActionButton.vue?vue&type=script&lang=ts"
export * from "./SheetActionButton.vue?vue&type=script&lang=ts"
import style0 from "./SheetActionButton.vue?vue&type=style&index=0&id=540a2ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a2ef0",
  null
  
)

export default component.exports